import * as React from "react";
import { DragSource, DropTarget } from "react-dnd";
import "./style.scss";

interface IDraggeableProps {
  className: string;
  move: (fromIndex: number, toIndex: number) => void;
  find: (id: number) => { draggable: any; index: number };
}

const dragSource = {
  beginDrag(props: any) {
    return {
      id: props.id,
      fromIndex: props.find(props.id).index
    };
  }
};

const cardTarget = {
  canDrop() {
    return false;
  },

  hover(props: any, monitor: any) {
    const dragged = monitor.getItem();
    const overId = props.id;

    if (dragged.id !== overId) {
      const overIndex = props.find(overId).index;
      const fromIndex = props.find(dragged.id).index;
      props.move(fromIndex, overIndex);
    }
  }
};

class Draggable extends React.Component<IDraggeableProps, {}> {
  render() {
    const { isDragging, connectDragSource, connectDropTarget } = this
      .props as any;
    return connectDragSource(
      connectDropTarget(
        <div
          className={`${this.props.className} draggable-item`}
          style={{ opacity: isDragging ? 0.5 : 1 }}
        >
          {this.props.children}
          <img className="drag-icon" src="/icon-drag.svg" />
        </div>
      )
    );
  }
}

export default DragSource("Draggable", dragSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
}))(
  DropTarget("Draggable", cardTarget, (connect) => ({
    connectDropTarget: connect.dropTarget()
  }))(Draggable)
);



// WEBPACK FOOTER //
// ./client/modules/core/Draggable/index.tsx